import { renderGroups } from "./renderGroups";
import { cleanPhoneNumber } from "./cleanPhoneNumber";
import { searchByName } from "./searchByName";
export function executeSearch(val) {
    val = val.toLowerCase().trim();
    const filteredGroups = {};
    Object.keys(window.groups).forEach((groupKey) => {
        filteredGroups[groupKey] = window.groups[groupKey].filter((family) => {
            var _a;
            const familyName = family["family-name"].toLowerCase();
            if (groupKey.toLowerCase().indexOf(val) === 0 ||
                searchByName(val, familyName)) {
                return true;
            }
            for (let i = 0; i < family.members.length; i++) {
                const member = family.members[i];
                if (("deacons".indexOf(val) > -1 &&
                    member.groups.indexOf("Deacons") > -1 &&
                    member.groups.indexOf("Elders") === -1) ||
                    ("elders".indexOf(val) > -1 &&
                        member.groups.indexOf("Elders") > -1) ||
                    member.groups
                        .map((group) => group.toLowerCase())
                        .indexOf(val) > -1 ||
                    ((_a = member.email) === null || _a === void 0 ? void 0 : _a.indexOf(val)) > -1 ||
                    cleanPhoneNumber(member.cell).indexOf(cleanPhoneNumber(val)) > -1) {
                    return true;
                }
            }
            return false;
        });
    });
    renderGroups(filteredGroups);
}
